import { OrderDetails_order_images } from "../types/OrderDetails";

export const orderImageIniData: OrderDetails_order_images[] = [
  { __typename: "OrderImage", alt: "", id: "", sortOrder: 0, url: "" }
];
